(() => {
  const desktop = window.matchMedia('(min-width: 990px)');
  const hover = window.matchMedia('(hover: hover)');
  const reset = root => {
    root.classList.remove('has-selection');
    root.querySelectorAll('[data-dhs-nav-expand]').forEach(b => b.setAttribute('aria-expanded', 'false'));
    root.querySelectorAll('.dhs-nav-category').forEach(e => e.classList.remove('is-selected'));
    root.querySelectorAll('[data-dhs-nav-panel]').forEach(e => { e.hidden = true; });
  };
  const init = () => document.querySelectorAll('[data-dhs-progressive-menu]').forEach(root => {
    if (root.dataset.dhsNavReady) return;
    root.dataset.dhsNavReady = 'true';
    root.style.setProperty('--dhs-nav-overview-columns', root.querySelectorAll('.dhs-nav-category').length >= 5 ? '3' : '2');
    const details = root.closest('details');
    const host = root.closest('header-menu');
    root.addEventListener('click', event => {
      const button = event.target.closest('[data-dhs-nav-expand]');
      if (!button || !root.contains(button)) return;
      const id = button.getAttribute('aria-controls');
      const panel = [...root.querySelectorAll('[data-dhs-nav-panel]')].find(e => e.id === id);
      if (!panel) return;
      const expand = button.getAttribute('aria-expanded') !== 'true';
      reset(root);
      if (expand) {
        root.classList.add('has-selection');
        button.setAttribute('aria-expanded', 'true');
        button.closest('.dhs-nav-category').classList.add('is-selected');
        panel.hidden = false;
      }
    });
    details.addEventListener('toggle', () => {
      if (!details.open) reset(root);
      details.querySelector(':scope > summary')?.setAttribute('aria-expanded', String(details.open));
    });
    let closeTimer;
    host.addEventListener('pointerenter', event => {
      if (!desktop.matches || !hover.matches || event.pointerType === 'touch') return;
      clearTimeout(closeTimer);
      document.querySelectorAll('header-menu > details[open]').forEach(other => { if (other !== details) other.open = false; });
      details.open = true;
    });
    host.addEventListener('pointerleave', () => {
      clearTimeout(closeTimer);
      closeTimer = setTimeout(() => {
        if (!host.matches(':hover') && !host.contains(document.activeElement)) details.open = false;
      }, 220);
    });
    host.addEventListener('focusout', () => {
      setTimeout(() => { if (!host.contains(document.activeElement) && !host.matches(':hover')) details.open = false; }, 0);
    });
    let handledEscape = false;
    root.addEventListener('keydown', event => {
      if (event.key !== 'Escape') return;
      const button = root.querySelector('[data-dhs-nav-expand][aria-expanded="true"]');
      if (!button) return;
      event.preventDefault();
      event.stopPropagation();
      handledEscape = true;
      reset(root);
      button.focus();
    });
    root.addEventListener('keyup', event => {
      if (event.key === 'Escape' && handledEscape) {
        event.preventDefault();
        event.stopPropagation();
        handledEscape = false;
      }
    });
    document.addEventListener('pointerdown', event => { if (!host.contains(event.target)) details.open = false; });
    desktop.addEventListener('change', () => { details.open = false; reset(root); });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
